import { useInfiniteQuery } from '@tanstack/react-query';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { useApiClient } from '../../../hooks';

const useGetQuestionVersions = (accessToken, questionId, organizationId) => {
  const apiClient = useApiClient(accessToken);

  const fetchQuestionVersions = async ({ pageParam = 1 }) => {
    const { data } = await apiClient.get(`/chat/questions/${questionId}/versions`, {
      params: decamelizeKeys({
        organizationId,
        page: pageParam,
        pageSize: 10
      })
    });
    return camelizeKeys(data);
  };

  const query = useInfiniteQuery(
    ['chat', 'questions', 'versions', questionId, organizationId],
    (args) => fetchQuestionVersions(args),
    {
      getNextPageParam: (lastPage) => {
        const { nextPage } = lastPage;
        return nextPage || undefined;
      },
      retry: false,
      enabled: Boolean(accessToken) && Boolean(questionId) && Boolean(organizationId)
    }
  );

  return query;
};

export { useGetQuestionVersions };
